import * as Yup from "yup";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { Request } from "../../hooks/Request";
import { validateArray } from "../../utils/validate";
import { Button } from "../../components/Buttons";
import { useModal } from "../../contexts/ModalContext";
import { requestAuth } from "../services/RequestService";
import FormDefault from "../../components/Forms/FormDefault";

const GeneralDataDim = ({ urlApi, reload }) => {
  const { procedureId } = useParams();

  const { data, loading, call } = Request({
    urlApi: urlApi ? urlApi : null,
  });

  function changeData(head) {
    let listResume = { head: head.head };
    if (validateArray(head.items)) {
      head.items.forEach((item) => {
        listResume = { ...listResume, [item.name]: item };
      });
    }
    return listResume;
  }

  if (!loading) {
    return null;
  }

  return (
    <div>
      <RenderGeneralData
        call={call}
        procedureId={procedureId}
        headA={changeData(data[0])}
        headB={changeData(data[1])}
        headC={changeData(data[2])}
        headD={changeData(data[3])}
        // headE={changeData(data[4])}
        Total={changeData(data[4])}
      />
    </div>
  );
};

const RenderGeneralData = (props) => {
  const { headA, headB, headC, headD, headE, Total, procedureId, call } = props;
  const { openModal, onClose } = useModal();

  function handleFields(json) {
    let resultInitial = {};
    let resultFields = [];
    let resultValidation = {};
    for (const fieldName in json) {
      const field = json[fieldName];
      //console.log(fieldName, field.validate);          
      resultInitial = {
        ...resultInitial,
        [field.name]:
          field.type !== "selectGetMultiple"        
            ? field.value || ""
            : field.value
            ? field.value.split(";").map((item) => ({  
                value: item,
                label: item,                          
              }))
            : "",
      };
      // "a3N°DeReferencia(Dam)": Yup.string().required("Campo requerido"),

      resultValidation = {
        ...resultValidation,
        [fieldName]: field.validate
          ? Yup.string().required("Campo requerido")
          : null,
      };
      console.log(field.label, field.fatherField);
      resultFields.push({
        ...field,
        label: field.label,
        name: field.name,
        placeholder: "Introduzca los datos",
        type: field.type,
        typeInput: field.type,
        fatherName:
          field.type === "subSelect" && field.fatherField
            ? field.fatherField.name
            : "",
        fatherUrl:
          field.type === "subSelect" && field.fatherField
            ? field.fatherField.url && field.fatherField.url.includes("/")
              ? field.fatherField.url
              : `/Dropdown/${field.fatherField.url}/options`
            : "",
        urlApi:
          field.type === "subSelect" && field.fatherField
            ? field.urlLabel
            : field.urlLabel
            ? field.urlLabel.includes("/")
              ? field.urlLabel
              : `/Dropdown/${field.urlLabel}/options`
            : "",
        value: "name",
        labelOption: "name",
        // lockEdition: field.name === "a1N°DeDeclaración(Dam)",
      });
    }
    return {
      initial: resultInitial,
      fields: resultFields,
      validate: resultValidation,
    };
  }

  function handleOpenForm(dataForm) {
    const { head, ...rest } = dataForm;
    const { initial, fields, validate } = handleFields(rest);
    console.log(fields);
    openModal(
      <FormDefault
        tittle={`Formulario de ${dataForm?.head}`}
        fields={fields}
        initialValues={initial}
        validationSchema={Yup.object().shape(validate)}
        onSubmit={async (values, resetForm) =>
          await onSubmit(values, resetForm, fields)
        }
        buttonName="Registrar"
      />
    );
  }

  async function onSubmit(values, resetForm, fields) {
    const result = validateArray(fields)
      ? fields.map((item) => {
          if (values[item.name]) {
            return {
              value:
                item.type === "selectGetMultiple"
                  ? validateArray(values[item.name])
                    ? values[item.name].map((item) => item.value).join(";")
                    : ""
                  : values[item.name],
              ProcedureId: procedureId,
              FieldId: item.fieldId,
            };
          }
          return null;
        })
      : [];
    await onSubmitDataSet(
      result.filter((n) => n),
      resetForm
    );
  }

  async function onSubmitDataSet(values, resetForm) {
    await requestAuth("post", "/dataset", values)
      .then(() => {
        call();
        resetForm();
        onClose();
        toast.success("Envio exitoso");
      })
      .catch((response) => {
        toast.error(
          response.response.data
            ? response.response.data
            : "Se ha producido un error al enviar"
        );
      });
  }

  const CellData = ({value, title, children, className }) => {
    return (
      <div
        className={`w-1/3 px-2 py-0 border-b-2 border-r-2 border-blue-900 ${className}`}
      >
        <h4 className="font-semibold">{title}</h4>
        <h4>{children}</h4>
      </div>
    );
  };

  return (
    <div>
      <div className="flex border-2 border-blue-900 mb-2 rounded-md">
        <div className="bg-blue-900 w-2"></div>
        <div className="w-full">
          <div className="w-full flex justify-start items-center gap-4 py-1 pl-3 text-lg font-semibold border-b-2 border-blue-900 text-blue-900 bg-blue-500">
            <h3 className="font-bold text-white">
              A. Identificación de la Declaración
            </h3>
            <Button
              onClick={() => handleOpenForm(headA)}
              className="w-[40px] h-[40px] flex items-center justify-center"
            >
              <i className="fab fa-wpforms"></i>
            </Button>
          </div>
          <div className="w-full flex">
            <CellData title="A3. N° de Referencia">
              {headA["a3N°DeReferencia(Dim)"]?.value}              
            </CellData>
            <CellData title="A4. Aduana de despacho">
              {headA["a4AduanaDeDespacho(Dim)"]?.value}
            </CellData>     
            <CellData className="border-r-0" title="A5 Destino/Régimen aduanero">
              {headA["a5CargaConsolidada(Dim)"]?.value}
            </CellData>       
          </div>
          <div className="w-full flex">            
            <CellData title="A6. Modalidad del régimen">
              {headA["a6Destino/RégimenAduanero(Dim)"]?.value}
            </CellData>
            <CellData className="border-t-0" title="A7. Modalidad de despacho">
              {headA["a7ModalidadDeRégimen(Dim)"]?.value}
            </CellData>
            <CellData className="border-r-0" title="A8. Tratamiento Especial">
              {headA["a8ModalidadDeDespacho(Dim)"]?.value}
            </CellData>
          </div>
          <div className="w-full flex">            
            {/* <CellData title="A9. Destino/Régimen Posterior a depósito">
              {headA["a9Destino/RégimenPosteriorADepósito(Dim)"]?.value}
            </CellData> */}
            <CellData
              className="border-b-0"
              title="A10. Nº documento asociado"
            >
              {headA["a10ModalidadDeDespachoPosteriorADepósito(Dim)"]?.value}
            </CellData>
            <CellData
              className="border-b-0"
              title="A11. Forma de envío"
            >
              {headA["a11EmisiónDeParteDeRecepción(Dim)"]?.value}
            </CellData>
            <CellData 
            className="border-b-0 border-r-0" 
            title="A12. Tipo de Despacho"
            >
              {headA["a12TipoDeMercancia(Dim)"]?.value}
            </CellData>
          </div>          
        </div>
      </div>
      <div className="flex border-2 border-blue-900 mb-2 rounded-md">
        <div className="bg-blue-900 w-2"></div>
        <div className="w-full">
          <div className="w-full flex justify-start items-center gap-4 py-1 pl-3 text-lg font-semibold border-b-2 border-blue-900 text-blue-900 bg-blue-500">
            <h3 className="font-bold text-white">B. Operadores</h3>
            <Button
              onClick={() => handleOpenForm(headB)}
              className="w-[40px] h-[40px] flex items-center justify-center"
            >
              <i className="fab fa-wpforms"></i>
            </Button>
          </div>
          <div className="w-full flex">
            <CellData title=""></CellData>
            <CellData title="Tipo de documento"></CellData>
            <CellData className="border-r-0" title="N° de documento"></CellData>
          </div>
          <div className="w-full flex">
            <CellData className="border-b-0" title="B1. Importador"></CellData>
            <CellData className="border-b-0" title="">
              {headB["b1TipoDeDocumento(Dim)"]?.value}
            </CellData>
            <CellData className="border-r-0 border-b-0" title="">
              {headB["b1NúmeroDeDocumento(Dim)"]?.value}
            </CellData>
          </div>
          {/* <div className="w-full flex">
            <CellData className="border-b-0" title="">
              B2. Consignatario
            </CellData>
            <CellData className="border-b-0" title="">
              {headB["b2TipoDeDocumento(Dim)"]?.value}
            </CellData>
            <CellData className="border-b-0 border-r-0" title="">
              {headB["b2NúmeroDeDocumento(Dim)"]?.value}
            </CellData>
          </div> */}
        </div>
      </div>
      <div className="flex border-2 border-blue-900 mb-2 rounded-md">
        <div className="bg-blue-900 w-2"></div>
        <div className="w-full">
          <div className="w-full flex justify-start items-center gap-4 py-1 pl-3 text-lg font-semibold border-b-2 border-blue-900 text-blue-900 bg-blue-500">
            <h3 className="font-bold text-white">C. Lugares</h3>
            <Button
              onClick={() => handleOpenForm(headC)}
              className="w-[40px] h-[40px] flex items-center justify-center"
            >
              <i className="fab fa-wpforms"></i>
            </Button>
          </div>
          <div className="w-full flex">
            <CellData title="C1. País de exportación">
              {headC["c1PaísDeExportación(Dim)"]?.value}
            </CellData>
            <CellData title="C2. Lugar de embarque">
              {headC["c2PaísDeProcedencia(Dim)"]?.value}
            </CellData>
            <CellData className="border-r-0" title="C3. Fecha de embarque">
              {headC["c3PaísDeTránsito(Dim)"]?.value}
            </CellData>
          </div>
          <div className="w-full flex">
            <CellData className="" title="C4. País de procedencia">
              {headC["c4AduanaDeIngreso(Dim)"]?.value}
            </CellData>
            <CellData className="" title="C5. País de tránsito">
              {headC["c5AduanaDeDestino(Dim)"]?.value}
            </CellData>
            <CellData
              className="border-r-0"
              title="C6. Aduana de ingreso"
            >
              {headC["c6LugarDeEntrega(Dim)"]?.value}
            </CellData>
          </div>
          <div className="w-full flex">
            <CellData className="border-b-0" title="C7. Departamento de destino">
              {headC["c4AduanaDeIngreso(Dim)"]?.value}
            </CellData>
            <CellData className="border-b-0" title="C8. Localidad de destino">
              {headC["c5AduanaDeDestino(Dim)"]?.value}
            </CellData>
            {/* <CellData
              className="border-b-0 border-r-0"
              title="C6. Lugar de entrega"
            >
              {headC["c6LugarDeEntrega(Dim)"]?.value}
            </CellData> */}
          </div>
        </div>
      </div>
      <div className="flex border-2 border-blue-900 mb-2 rounded-md">
        <div className="bg-blue-900 w-2"></div>
        <div className="w-full">
          <div className="w-full flex justify-start items-center gap-4 py-1 pl-3 text-lg font-semibold border-b-2 border-blue-900 text-blue-900 bg-blue-500">
            <h3 className="font-bold text-white">D. Transporte</h3>
            <Button
              onClick={() => handleOpenForm(headD)}
              className="w-[40px] h-[40px] flex items-center justify-center"
            >
              <i className="fab fa-wpforms"></i>
            </Button>
          </div>
          <div className="w-full flex">
            <div className="w-full px-2 py-0 border-b-2 border-blue-900">
              <h4 className="font-semibold">D3.1. Proviene de Zona Franca:</h4>
              <h4>{headD["d1N°DeDocumentoDeEmbarque(Dim)"]?.value}</h4>
            </div>
          </div>
          <div className="w-full flex">
            <CellData
              className="border-b-0"
              title="D2. Modalidad de transporte hasta frontera"
            >
              {headD["d2ModalidadDeTransporteHastaFrontera(Dim)"]?.value}
            </CellData>
            <CellData
              className="border-b-0"
              title="D3. Modalidad de transporte desde frontera"
            >
              {headD["d3ModalidadDeTransporteDesdeFrontera(Dim)"]?.value}
            </CellData>
            <CellData
              className="border-b-0 border-r-0"
              title="D4. Carga peligrosa"
            >
              {headD["d4CargaPeligrosa(Dim)"]?.value}
            </CellData>
          </div>
        </div>
      </div>
      <div className="flex border-2 border-blue-900 mb-2 rounded-md">
        <div className="bg-blue-900 w-2"></div>
        <div className="w-full">
          <div className="w-full flex justify-start items-center gap-4 py-1 pl-3 text-lg font-semibold border-b-2 border-blue-900 text-blue-900 bg-blue-500">
            <h3 className="font-bold text-white">D4. Gastos de transporte hasta el lugar de importación</h3>
            <Button
              onClick={() => handleOpenForm(headD)}
              className="w-[40px] h-[40px] flex items-center justify-center"
            >
              <i className="fab fa-wpforms"></i>
            </Button>
          </div>
          <div className="w-full flex">
            <div className="w-2/3 px-2 py-0 border-b-2 border-r-2 border-blue-900">
              <h4 className="font-semibold">D4.1. Gastos de transporte, manejo y entrega en el exterior hasta el lugar de embarque</h4>
              <h4>{headD["d1N°DeDocumentoDeEmbarque(Dim)"]?.value}</h4>              
            </div>
            <CellData
              className="border-b-2 border-r-0"
              title=""
            >
              {headD["d2ModalidadDeTransporteHastaFrontera(Dim)"]?.value}
            </CellData>
          </div>
          <div className="w-full flex">
            <div className="w-2/3 px-2 py-0 border-b-2 border-r-2 border-blue-900">
              <h4 className="font-semibold">D4.2. Gastos de transporte hasta el puerto de tránsito</h4>
              <h4>{headD["d1N°DeDocumentoDeEmbarque(Dim)"]?.value}</h4>              
            </div>
            <CellData
              className="border-b-2 border-r-0"
              title=""
            >
              {headD["d2ModalidadDeTransporteHastaFrontera(Dim)"]?.value}
            </CellData>
          </div>
          <div className="w-full flex">
            <div className="w-2/3 px-2 py-0 border-b-2 border-r-2 border-blue-900">
              <h4 className="font-semibold">D4.3. Gastos de transporte hasta el puerto de tránsito o lugar de importación</h4>
              <h4>{headD["d1N°DeDocumentoDeEmbarque(Dim)"]?.value}</h4>              
            </div>
            <CellData
              className="border-b-2 border-r-0"
              title=""
            >
              {headD["d2ModalidadDeTransporteHastaFrontera(Dim)"]?.value}
            </CellData>
          </div>
          <div className="w-full flex">
            <div className="w-2/3 px-2 py-0 border-b-2 border-r-2 border-blue-900">
              <h4 className="font-semibold">D5. Gastos de carga, descarga y manipulación (contempla gastos portuarios)</h4>
              <h4>{headD["d1N°DeDocumentoDeEmbarque(Dim)"]?.value}</h4>              
            </div>
            <CellData
              className="border-b-2 border-r-0"
              title=""
            >
              {headD["d2ModalidadDeTransporteHastaFrontera(Dim)"]?.value}
            </CellData>
          </div>
          <div className="w-full flex">
            <div className="w-2/3 px-2 py-0 border-b-2 border-r-2 border-blue-900">
              <h4 className="font-semibold">D6. Costo de seguro</h4>
              <h4>{headD["d1N°DeDocumentoDeEmbarque(Dim)"]?.value}</h4>              
            </div>
            <CellData
              className="border-b-2 border-r-0"
              title=""
            >
              {headD["d2ModalidadDeTransporteHastaFrontera(Dim)"]?.value}
            </CellData>
          </div>
          <div className="w-full flex">
            <div className="w-2/3 px-2 py-0 border-b-2 border-r-2 border-blue-900">
              <h4 className="font-semibold">D7. Otros gastos</h4>
              <h4>{headD["d1N°DeDocumentoDeEmbarque(Dim)"]?.value}</h4>              
            </div>
            <CellData
              className="border-b-2 border-r-0"
              title=""
            >
              {headD["d2ModalidadDeTransporteHastaFrontera(Dim)"]?.value}
            </CellData>
          </div>
          <div className="w-full flex">
            <div className="w-2/3 px-2 py-0 border-b-2 border-r-2 border-blue-900">
              <h4 className="font-semibold">D8. Otras erogaciones no facturadas necesarias para el despacho aduanero</h4>
              <h4>{headD["d1N°DeDocumentoDeEmbarque(Dim)"]?.value}</h4>              
            </div>
            <CellData
              className="border-b-2 border-r-0"
              title=""
            >
              {headD["d2ModalidadDeTransporteHastaFrontera(Dim)"]?.value}
            </CellData>
          </div>
        </div>
      </div>
      <div className="flex border-2 border-blue-900 mb-2 rounded-md">
        <div className="bg-blue-900 w-2"></div>
        <div className="w-full">
          <div className="w-full flex justify-start items-center gap-4 py-1 pl-3 text-lg font-semibold border-b-2 border-blue-900 text-blue-900 bg-blue-500">
            <h3 className="font-bold text-white">
              Totales para control de la declaración
            </h3>
            <Button
              onClick={() => handleOpenForm(Total)}
              className="w-[40px] h-[40px] flex items-center justify-center"
            >
              <i className="fab fa-wpforms"></i>
            </Button>
          </div>
          <div className="w-full flex">
            <CellData title="Total N° facturas">
              {Total["TotalN°Facturas(Dim)"]?.value}
            </CellData>
            <CellData title="Valor FOB Total (USD)">
              {Total["ValorFOBTotal(USD)(Dim)"]?.value}
            </CellData>
            <CellData className="border-r-0" title="Total N° de bultos">
              {Total["totalN°DeBultos(Dim)"]?.value}
            </CellData>
          </div>
          <div className="w-full flex">
            <CellData className="border-b-0" title="Total peso bruto [kg]">
              {Total["totalPesoBruto(kg)(Dim)"]?.value}
            </CellData>
            <CellData className="border-b-0" title="Total peso neto [kg]">
              {Total["totalPesoNeto(kg)(Dim)"]?.value}
            </CellData>
            <CellData
              className="border-b-0 border-r-0"
              title=""
            >
              {Total[""]?.value}
            </CellData>
          </div>
        </div>
      </div>
      <br />
      <div className=""></div>
    </div>
  );
};

export default GeneralDataDim;
